import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ModuleHeading from "../../Shared/ModuleHeading/ModuleHeading";

import ShipmentOverview from "./components/ShipmentOverview";
import TrackMap from "./components/TrackMap";
import RightSideBar from "./components/RightSideBar";
import TrackingTabs from "./components/TrackingTabs";
import ShipmentOverviewSkeleton from "./components/ShipmentOverviewSkeleton";
import RightSideBarSkeleton from "./components/RightSideBarSkeleton";
import MapLoader from "./components/MapLoader";
import { useTrackDetailsData } from "./hooks/useTrackDetailsData";
import { useHistory } from "react-router-dom";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import useViewOnlyAccess from "../../../hooks/useViewOnlyAccess";

const TrackDetails = () => {
  const history = useHistory();
  const { userDetails } = useContext(UserApiContext)
  const { companySettingData } = useContext(MyCompanyProfileContext)

  const { indent_id, indent_id_sub } = useParams();
  const { isRestricted } = useViewOnlyAccess('indent', 'lorri_indent_tracking', true);
  const { loadingIndentDetails, loadingTruckLocation, loadingSimTracking, err, simErr, fetchTruckLocation, fetchSimTracking, data, simData, fetchIndentDetails, globalErr } =
    useTrackDetailsData(indent_id, indent_id_sub);

  const [activeTab, setActiveTab] = useState("fastag");
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  useEffect(() => {
    TrackMixPanel({
      Definition: "user has viewed the track and trace screen.",
      ModuleName: "lorri vehicle tracking",
      ScreenName: "indent request - track and trace",
      Data: {
        Route: data?.route,
      },
    });
  }, [data?.route]);

  // handle unauth error
  if (!loadingIndentDetails && !loadingTruckLocation && globalErr !== null)
    return (
      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{ minHeight: "88vh" }}
      >
        <span className="text-center text-muted">{globalErr}</span>
      </div>
    );
  return (
    <div>
    <div style={{ position: 'relative' }}>
      <ModuleHeading
        title="Track And Trace"
        titleClassName="my-2"
        onClickBack={() => history.push("/indenttracking")}
      />
    </div>
      <div
        style={{ backgroundColor: "whitesmoke" }}
        className="container-fluid py-3 py-md-4"
      >
        <div className="row g-3 g-xl-4">
          {/* LEFT: Shipment Overview */}
          {loadingIndentDetails ? (
            <ShipmentOverviewSkeleton />
          ) : (
            <ShipmentOverview
              err={err}
              apiCall={() => {
                fetchIndentDetails();
                fetchTruckLocation();
                fetchSimTracking();
              }}
              loading={false}
              data={data}
              carrier={data.carrier}
            />
          )}

          {/* CENTER: Map */}
          <div className="col-12 col-xl-6">
            <div className="card shadow-sm border-0">
              <div className="card-body p-2" style={{ position: "relative" }}>
                {userDetails?.policy?.indents?.allowed_sim_tracking === "yes" && <TrackingTabs activeTab={activeTab} onTabChange={setActiveTab} />}
                <TrackMap
                  err={activeTab === "fastag" ? err : simErr}
                  data={activeTab === "fastag" ? data : simData}
                  activeTab={activeTab}
                  height="76vh"
                />
                {(activeTab === "fastag" ? loadingTruckLocation : loadingSimTracking) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 480,
                      borderRadius: "4px",
                    }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      {/* <span className="visually-hidden">Loading...</span> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT: Sidebar */}
          {loadingIndentDetails ? (
            <RightSideBarSkeleton height="71vh" />
          ) : (
            <RightSideBar
              data={activeTab === "fastag" ? data : simData}
              err={activeTab === "fastag" ? err : simErr}
              height="71vh"
              indentId={indent_id}
              activeTab={activeTab}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackDetails;
